/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Modal, Typography } from 'antd';

const { Text } = Typography;

/**
 * Renderiza error 40x en un modal detallado de errores.-
 *
 * @param titleError Título del mensaje de error.
 * @param errorData Array de errores.
 */
const renderError40x = (titleError, errorData) => {
  Modal.error({
    title: titleError,
    content: (
      <>
        {errorData.errors ? (
          errorData.errors.map(err => (
            <Text key={`${err.param}-${err.value}`}>
              <strong>{err.value}</strong>: {err.msg}
            </Text>
          ))
        ) : (
          <Text>{errorData}</Text>
        )}
      </>
    ),
  });
};

export { renderError40x };
